// Utility cookie helpers (non-httpOnly cookies only). HttpOnly cookies cannot be manipulated via JS.
export const deleteCookie = (name) => {
  try {
    document.cookie = `${name}=; Max-Age=0; path=/`;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[cookies] deleteCookie failed', name, e?.message);
  }
};
